export interface FailureNotification {
    id: string;
    wellStringId: string;
    platformShortName: string;
    platformLongName: string;
    fieldShortName: string;
    fieldLongName: string;
    wellShortName: string;
    wellLongName: string;
    stringShortName: string;
    stringLongName: string;
    stringIndicatorShortName: string;
    wellProductionStatus: string;
    status: string;
    preparedBy: string;
    approvedBy: string;
    failureDate: string;
    failEquipment: string;
    probleReported: string;
    detailDesc: string;
    forwardActionPlan: string;
    inputDate: string;
    problemReported: string;
    isWellHealthy: boolean;
    riskRanking: number;
}


export enum FNStatus {
    DRAFT = 'Draft',
    READY = 'Ready to Review',
    REJECTED = 'Rejected',
    APPROVED = 'Approved'
}